module.exports = __webpack_public_path__ + "img/yyt2.8f8254d4.png";